import {
	POST
} from  './Request.js';
let app = getApp();
let base = app.globalData.url;
//H5 获取用户信息
export const mpLogin = params => {
	return POST('POST', `${base}/wechat/mpLogin`, params).then(res => res.data);
}

//查询优惠券
export const getDiscountList = params => {
	return POST('GET', `${base}/discount/getDiscountList`, params).then(res => res.data);
}